import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/view/home'
import storage from '@/common/storage.js'

// 懒加载方式，当路由被访问的时候才加载对应组件
const Login = resolve => require(['@/view/login'], resolve)

Vue.use(Router)

let router = new Router({
    mode: "history",
    routes: [
        {
            path: "/login",
            name: "/login",
            component: Login,
            meta: {
                title: "登录",
            },
        },
        {
            path: "/home",
            name: "/home",
            component: Home,
        },
        {
            path: "/",
            component: Home,
            redirect: "/home",
            leaf: true, // 只有一个节点
            meta: {
                title: "首页",
            },
        },
        {
            path: "/users",
            name: "/users",
            redirect: "/users/users-manage",
            component: Home,
            children: [
                {
                    path: "/users/users-manage",
                    name: "usersManage",
                    component: resolve => {
                        require(["@/view/Users/users-manage.vue"], resolve);
                    },
                    meta: {
                        title: "用户管理",
                    },
                }
            ],
        },
        {
            path: "/system",
            name: "/system",
            redirect: "/system/account-manage",
            component: Home,
            children: [
                {
                    path: "/system/account-manage",
                    name: "accountManage",
                    component: resolve => {
                        require(["@/view/System/account-manage.vue"], resolve);
                    },
                    meta: {
                        title: "账号管理",
                        keepAlive: true, // 需要被缓存
                        isBack: false, //用于判断上一个页面是哪个
                    },
                },
                {
                    path: "/system/account-edit",
                    name: "accountEdit",
                    component: resolve => {
                        require(["@/view/System/account-edit.vue"], resolve);
                    },
                },
                {
                    path: "/system/role-manage",
                    name: "roleManage",
                    component: resolve => {
                        require(["@/view/System/role-manage.vue"], resolve);
                    },
                    meta: {
                        title: "角色管理",
                        keepAlive: true, // 需要被缓存
                        isBack: false, //用于判断上一个页面是哪个
                    },
                },
                {
                    path: "/system/role-edit",
                    name: "roleEdit",
                    component: resolve => {
                        require(["@/view/System/role-edit.vue"], resolve);
                    },
                },
                {
                    path: "/system/ant-mini-programs-info",
                    name: "antMiniProgramsInfo",
                    component: resolve => {
                        require(["@/view/System/ant-mini-programs-info.vue"], resolve);
                    },
                    meta: {
                        title: "用户小程序信息管理"
                    },
                },
                {
                    path: "/system/trade-split-settings",
                    name: "tradeSplitSettings",
                    component: resolve => {
                        require(["@/view/System/trade-split-settings.vue"], resolve);
                    },
                    meta: {
                        title: "分账模板信息管理",
                    },
                }
            ],
        },
        {
            path: "/tenants",
            name: "/tenants",
            redirect: "/tenants/tenants-manage",
            component: Home,
            children: [
                {
                    path: "/tenants/tenants-manage",
                    name: "tenantsManage",
                    component: resolve => {
                        require([
                            "@/view/Tenants/tenants-manage.vue",
                        ], resolve);
                    },
                    meta: {
                        title: "商户管理",
                        keepAlive: true, // 需要被缓存
                        isBack: false, //用于判断上一个页面是哪个
                    },
                },
                {
                    path: "/tenants/tenants-detail",
                    name: "tenantsDetail",
                    component: resolve => {
                        require(["@/view/Tenants/tenants-detail.vue"], resolve);
                    },
                    meta: {
                        title: "商户详情"
                    },
                }
            ],
        },
        {
            path: "/product",
            name: "/product",
            redirect: "/product/product-category-manage",
            component: Home,
            children: [
                {
                    path: "/product/product-category-manage",
                    name: "productCategoryManage",
                    component: resolve => {
                        require([
                            "@/view/Product/product-category-manage.vue",
                        ], resolve);
                    },
                    meta: {
                        title: "产品大类管理",
                        keepAlive: true, // 需要被缓存
                        isBack: false, //用于判断上一个页面是哪个
                    },
                },
                {
                    path: "/product/product-category-edit",
                    name: "productCategoryEdit",
                    component: resolve => {
                        require(["@/view/Product/product-category-edit.vue"], resolve);
                    },
                },
                {
                    path: "/product/primary-product-category-manage",
                    name: "primaryProductCategoryManage",
                    component: resolve => {
                        require([
                            "@/view/Product/primary-product-category-manage.vue",
                        ], resolve);
                    },
                    meta: {
                        title: "产品一级分类管理",
                        keepAlive: true, // 需要被缓存
                        isBack: false, //用于判断上一个页面是哪个
                    },
                },
                {
                    path: "/product/primary-product-category-edit",
                    name: "primaryProductCategoryEdit",
                    component: resolve => {
                        require(["@/view/Product/primary-product-category-edit.vue"], resolve);
                    },
                },
                {
                    path: "/product/service-items-manage",
                    name: "serviceItemsManage",
                    component: resolve => {
                        require([
                            "@/view/Product/service-items-manage.vue",
                        ], resolve);
                    },
                    meta: {
                        title: "服务项管理",
                        keepAlive: true, // 需要被缓存
                        isBack: false, //用于判断上一个页面是哪个
                    },
                },
                {
                    path: "/product/service-items-edit",
                    name: "serviceItemsEdit",
                    component: resolve => {
                        require(["@/view/Product/service-items-edit.vue"], resolve);
                    },
                },
                {
                    path: "/product/specs-manage",
                    name: "specsManage",
                    component: resolve => {
                        require([
                            "@/view/Product/specs-manage.vue",
                        ], resolve);
                    },
                    meta: {
                        title: "规格管理",
                        keepAlive: true, // 需要被缓存
                        isBack: false, //用于判断上一个页面是哪个
                    },
                },
                {
                    path: "/product/specs-edit",
                    name: "specsEdit",
                    component: resolve => {
                        require(["@/view/Product/specs-edit.vue"], resolve);
                    },
                },
                {
                    path: "/product/secondary-product-category-manage",
                    name: "secondaryProductCategoryManage",
                    component: resolve => {
                        require([
                            "@/view/Product/secondary-product-category-manage.vue",
                        ], resolve);
                    },
                    meta: {
                        title: "产品二级分类管理",
                        keepAlive: true, // 需要被缓存
                        isBack: false, //用于判断上一个页面是哪个
                    },
                },
                {
                    path: "/product/secondary-product-category-edit",
                    name: "secondaryProductCategoryEdit",
                    component: resolve => {
                        require(["@/view/Product/secondary-product-category-edit.vue"], resolve);
                    },
                },
                {
                    path: "/product/price-edit",
                    name: "priceEdit",
                    component: resolve => {
                        require(["@/view/Product/price-edit.vue"], resolve);
                    },
                },
            ],
        },
        {
            path: "/templates",
            name: "/templates",
            redirect: "/templates/templates-manage",
            component: Home,
            children: [
                {
                    path: "/templates/templates-manage",
                    name: "templatesManage",
                    component: resolve => {
                        require([
                            "@/view/Templates/templates-manage.vue",
                        ], resolve);
                    },
                    meta: {
                        title: "模板管理",
                        keepAlive: true, // 需要被缓存
                        isBack: false, //用于判断上一个页面是哪个
                    },
                },
                {
                    path: "/templates/templates-detail",
                    name: "templatesList",
                    component: resolve => {
                        require(["@/view/Templates/templates-detail.vue"], resolve);
                    },
                    meta: {
                        title: "模板详情",
                    },
                },
                {
                    path: "/templates/template-releases-manage",
                    name: "templateReleasesManage",
                    component: resolve => {
                        require(["@/view/Templates/template-releases-manage.vue"], resolve);
                    },
                    meta: {
                        title: "模板发布版本管理",
                    },
                },
            ],
        },
        {
            path: "/orders",
            name: "/orders",
            redirect: "/orders/orders-manage",
            component: Home,
            children: [
                {
                    path: "/orders/orders-manage",
                    name: "ordersManage",
                    component: resolve => {
                        require(["@/view/Orders/orders-manage.vue"], resolve);
                    },
                    meta: {
                        title: "订单管理",
                        keepAlive: true, // 需要被缓存
                        isBack: false, //用于判断上一个页面是哪个
                    }
                },
                {
                    path: "/orders/orders-detail",
                    name: "ordersDetail",
                    component: resolve => {
                        require(["@/view/Orders/orders-detail.vue"], resolve);
                    },
                    meta: {
                        title: "订单详情"
                    }
                }
            ],
        },
        {
            path: "/fund",
            name: "/fund",
            redirect: "/fund/trade-split-records",
            component: Home,
            children: [
                {
                    path: "/fund/trade-split-records",
                    name: "tradeSplitRecords",
                    component: resolve => {
                        require(["@/view/Fund/trade-split-records.vue"], resolve);
                    },
                    meta: {
                        title: "分账记录",
                        keepAlive: true, // 需要被缓存
                        isBack: false //用于判断上一个页面是哪个
                    }
                }
            ],
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        const dom = document.getElementsByClassName("content-container");
        if (dom.length > 0) dom && dom[0].scrollTo(0, 0);
    },
});

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    if (to.path.startsWith('/login')) {
        let token = storage.getToken()
        if (token) {
            next({
                path: '/'
            })
        } else {
            next()
        }
    } else {
        let token = storage.getToken()
        if (token) {
            next()
        } else {
            next({
                path: '/login'
            })
        }
    }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js